export default {
  nav: {
    findBarber: 'Gjej një berber'
  },
  navigation: {
    home: 'Kreu',
    aboutUs: 'Rreth nesh',
    contactUs: 'Kontakt',
    demo: 'Demo',
    login: 'Hyr',
    language: 'Gjuha',
    logo: 'Logo',
    toggleMenu: 'Hap/mbyll menunë',
    changeLanguage: 'Ndrysho gjuhën',
    scrollToTop: 'Kthehu në krye',
    joinAsBarber: 'Bashkohu si berber',
    pricing: 'Çmimet',
    signUp: 'Regjistrohu'
  },
  home: {
    hero: {
      eyebrow: 'Po pranojmë berberë në Sofje - kanë mbetur vetëm 3 vende këtë javë',
      mainTitle: 'Karrigia jote.<br>Orari yt.<br><span class="hero-title-accent">Rritja jote.</span>',
      mainDesc: "Ke vite që e përsos zanatin tënd. Nuk ke pse i harxhon mbrëmjet duke kthyer përgjigje në WhatsApp. Barbers Unity të jep një faqe profesionale rezervimi dhe një kalendar të plotë - kështu që ti fokusohesh te qethja, jo te gjuetia e klientëve.",
      growBusiness: 'Dua më shumë klientë',
      seeDashboard: 'Shiko panelin',
      trustText: '<strong>Petar Barbov</strong> dhe berberë nga e gjithë Evropa janë tashmë në platformë.',
      joinThem: 'Bashkohu me ta →'
    },
    pain: {
      label: 'Të duket e njohur?',
      answer: 'Barbers Unity i zgjidh të gjitha këto.',
      items: [
        'Klientët të marrin në telefon fiks kur je duke qethur',
        'Klientë që nuk paraqiten dhe të djegin oraret më të mira',
        'Harron të konfirmosh rezervimet në WhatsApp',
        'Rezervime të dyfishta që të vënë në siklet',
        'Përdorimi i një blloku letre në vitin 2025'
      ]
    },
    mobile: {
      label: 'Menaxhim nga xhepi',
      title: 'Menaxho sallonin tënd nga kudo.',
      desc: "Ti nuk punon pas një tavoline. Barbers Unity është plotësisht i optimizuar për celularin tënd. Kontrollo orarin, prano rezervime dhe shiko historikun e klientëve mes qethjeve.",
      list: [
        'Njoftime të menjëhershme për rezervime të reja',
        'Shiko të gjithë historikun e klientit me një shikim',
        'Shto klientët pa orar në kalendar për vetëm 3 sekonda'
      ]
    },
    featuresList: [
      { title: 'Faqja jote personale e rezervimeve', desc: 'Një link profesional që e ndan kudo - Instagram bio, WhatsApp, Google. Klientët rezervojnë vetë, 24/7.' },
      { title: 'Kalendar inteligjent', desc: 'Shiko të gjithë javën me një shikim. Blloko kohën personale, vendos orarin e punës, dhe mos lejo më kurrë rezervime të dyfishta.' },
      { title: 'Baza e klientëve', desc: "Historiku dhe detajet e kontaktit të çdo klienti - të organizuara, të lehta për t'u gjetur dhe gjithmonë pranë." },
      { title: 'Platformë ndërkombëtare', desc: 'Ndërtuar për berberët në të gjithë Evropën. Mbështet EN, BG, HR, ALB, GER dhe vazhdon të rritet.' }
    ],
    calendar_preview: {
      title: 'Kalendari yt, në çdo pajisje.'
    },
    how: {
      label: 'Si të fillosh',
      title: 'Gati për punë në më pak se 10 minuta'
    },
    stepsList: [
      { title: 'Krijo Profilin Tënd', desc: 'Regjistrohu në pak minuta. Shto shërbimet, vendos orarin dhe merr menjëherë linkun tënd profesional të rezervimit. Nuk kërkohen aftësi teknike.' },
      { title: 'Ndaj linkun tënd të rezervimit', desc: 'Vendose në bio-n tënde në Instagram, në statusin e WhatsApp ose dërgoja klientëve të tu të rregullt. Ata rezervojnë në pak sekonda.' },
      { title: 'Thjesht shko në punë dhe qeth', desc: 'Kalendari menaxhon veten. Ti thjesht fokusohu te qethja dhe te rritja e emrit tënd.' }
    ],
    trust: {
      card1: { title: 'Ne bëjmë pjesën më të vështirë', desc: "Të tremb ndryshimi i sistemit? Mos u shqetëso. Na dërgo listën e klientëve të tu (Excel, eksport nga Booksy ose foto të bllokut të vjetër) dhe ne do t'i hedhim klientët dhe do të krijojmë profilin tënd falas." },
      card2: { title: 'Pronësi 100% mbi të dhënat', desc: 'Platformat e tjera i përdorin klientët e tu për t\'u promovuar berberë konkurrentë. Me Barbers Unity, lista e klientëve është rreptësisht e jotja. Ne kurrë nuk i shesim të dhënat e tua dhe nuk u dërgojmë reklama klientëve të tu.' }
    },
    testimonial: {
      quote: "Para Barbers Unity, humbisja 3-4 rezervime në javë vetëm nga thirrjet e humbura dhe mesazhet në WhatsApp që harroja t'u ktheja përgjigje. Me 20 € për qethje, ato janë 240-320 € që i humbisja çdo muaj. Tani kalendari im mbushet vetë. Thjesht shkoj në punë dhe qeth.",
      name: 'Petar Barbov',
      role: 'Berber Profesionist · Ndër anëtarët e parë'
    },
    stats: {
      label: 'Aktiviteti në platformë',
      title: 'Shifra reale, që rriten çdo ditë',
      bookings: 'Rezervime të menaxhuara',
      clients: 'Klientë të shërbyer',
      time: 'Koha administrative e kursyer për berber / javë'
    },
    pricing: {
      label: 'Çmime të drejta',
      title: 'Mos paguaj komisione për suksesin tënd',
      desc: 'Platformat e tjera të dënojnë kur ke më shumë punë, duke të faturuar për çdo rezervim. Ne besojmë se atë që fiton, duhet ta mbash për vete.',
      competitorNote: 'Sapo një berber konkurrent në qytetin tënd të marrë vendin e tij, ai fiton avantazhin. Berberi i parë i zonës merr pozicionim prioritar në kërkimin e klientëve.',
      identityLine: 'Ndërtuar për berberët që e trajtojnë këtë si një biznes, jo si një hobi.',
      them: {
        label: 'Konkurrentët',
        list: [ 'Tarifë për çdo rezervim', 'Kosto të fshehura dhe të papritura', 'Kostot rriten kur ke më shumë punë' ],
        price: 'Deri në 200 €',
        sub: '/muaj'
      },
      vs: 'VS',
      us: {
        label: 'Barbers Unity',
        list: [ 'Rezervime të pakufizuara', 'Zero komisione, pa tarifa të fshehura', 'Mbaj 100% të të ardhurave të tua' ],
        price: '35 €',
        sub: '/muaj fiks'
      }
    },
    calc: {
      label: 'Kalkulatori i të ardhurave',
      title: "Shiko sa po humbet",
      desc: 'Çdo rezervim i humbur do të thotë para më pak. Lëviz rrëshqitësit për të parë se sa më shumë mund të fitosh çdo muaj.',
      button: 'Fillo të fitosh më shumë',
      cuts: 'Qethje në ditë',
      price: 'Çmimi për qethje (€)',
      missed: 'Rezervime të humbura në javë',
      monthlyNow: 'Të ardhurat mujore tani',
      withUs: 'Me Barbers Unity',
      recovered: '/ në muaj të rikuperuara',
      lossThisMonth: 'të humbura tashmë këtë muaj'
    },
    faq: {
      label: 'Ke pyetje?',
      title: 'Pyetje të Shpeshta'
    },
    faqList: [
      { q: "A duhet që klientët e mi të shkarkojnë një aplikacion?", a: "Jo! Klientët e tu rezervojnë përmes një linku të pastër dhe të shpejtë direkt nga shfletuesi i tyre. Pa shkarkuar aplikacione, pa hapur llogari, dhe pa asnjë vështirësi për ta." },
      { q: "Si paguhem?", a: "Ti mban 100% të asaj që fiton. Klientët të paguajnë direkt në dyqan siç bëjnë gjithmonë. Ne nuk mbajmë asnjë përqindje apo komision nga puna jote." },
      { q: "A jam i lidhur me kontratë?", a: "Absolutisht jo. Barbers Unity ofrohet me një abonim fiks mujor. Je i lirë ta anulosh kur të duash." },
      { q: "Unë tashmë përdor një sistem tjetër. A është e vështirë të kaloj te ju?", a: "Kërkon 0 përpjekje nga ana jote. Na dërgo listën aktuale të klientëve dhe ne do të importojmë gjithçka dhe do ta ndërtojmë profilin për ty, plotësisht falas." }
    ],
    upcoming: {
      label: 'Së shpejti',
      title: 'Mjete akoma më të fuqishme, rrugës',
      badge: 'Së shpejti'
    },
    upcomingList: [
      { title: 'Kujtesa automatike', desc: 'Kujtesa me email dhe WhatsApp që dërgohen para çdo takimi - mosparaqitjet do t\'i përkasin të shkuarës.' },
      { title: 'Analiza & pasqyra e të ardhurave', desc: 'Shiko cilat janë shërbimet e tua më të mira, orët më të ngarkuara dhe klientët kryesorë - merr vendime më të zgjuara për biznesin tënd.' },
      { title: 'Sistem besnikërie', desc: 'Shpërble klientët e rregullt, gjurmo vizitat e tyre dhe bëji të kthehen sërish përmes sistemit tonë të integruar.' }
    ],
    cta: {
      eyebrow: 'Vende të kufizuara - rezervo para se të mbushen',
      title: 'Gati për ta mbushur kalendarin?',
      sub: 'Bashkohu me berberët që e drejtojnë vetë biznesin e tyre - jo anasjelltas.',
      microYes: [
        'Dua një kalendar të mbushur plot çdo javë',
        'Nuk dua asnjë mosparaqitje (no-show)',
        'Nuk dua të bëj më rolin e recepsionistit'
      ],
      findBarber: 'Gjej një berber afër teje',
      member: 'Je tashmë anëtar?',
      login: 'Hyr në panelin tënd →'
    },
    pricingCta: {
      title: 'Gati për ta rritur sallonin tënd?',
      subtitle: '35 €/muaj · Muaji i parë falas',
      button: 'Fillo tani'
    }
  },
  about: {
    title: 'Rreth Barbers Unity',
    description: "Ne po ndryshojmë rrënjësisht mënyrën se si berberët lidhen me klientët e tyre. Platforma jonë i ndihmon berberët të tregojnë punën e tyre, të menaxhojnë oraret dhe ta rritin biznesin në mënyrë efikase.",
    founded: 'Themeluar në vitin 2025, Barbers Unity është rritur nga një ide e thjeshtë në një platformë të plotë që u shërben berberëve në shumë shtete.',
    ourStory: 'Historia Jonë',
    whatDrivesUs: 'Çfarë Na Shtyn',
    mission: {
      title: 'Misioni Ynë',
      description: 'Të thjeshtojmë dhe modernizojmë procesin e rezervimit për berberët'
    },
    vision: {
      title: 'Vizioni Ynë',
      description: 'Të krijojmë komunitetin më të madh të berberëve të lidhur me njëri-tjetrin në mbarë botën'
    },
    values: {
      title: 'Vlerat Tona',
      description: 'Cilësi, Besim dhe Rritje Profesionale'
    },
    built: {
      label: 'Krijuar për këtë zanat',
      title: 'Ne e dimë si është të jesh pas karriges.',
      desc1: "Barbers Unity nuk u krijua nëpër zyra korporatash. U krijua sepse pamë berberë të mrekullueshëm - të talentuar, të kërkuar, të respektuar - që humbisnin klientë nga telefonatat e pakthyera dhe sistemet e këqija të rezervimeve që nuk ishin bërë për ta.",
      desc2: 'Ne ndërtuam platformën që donim të ekzistonte: një platformë që e merr zanatin tënd seriozisht, e vë emrin tënd të parin dhe merret me pjesën administrative që ti mos ta vrasësh më mendjen për të.',
      stats: {
        countries: 'Shtetet ku operojmë',
        time: 'Për të filluar punë',
        cost: 'Kostoja e konfigurimit'
      }
    },
    testimonial: {
      quote: "Para Barbers Unity, humbisja 3-4 rezervime në javë vetëm nga thirrjet e humbura dhe mesazhet në WhatsApp që harroja t'u ktheja përgjigje. Me 20 € për qethje, ato janë 240-320 € që i humbisja çdo muaj. Tani kalendari im mbushet vetë. Thjesht shkoj në punë dhe qeth.",
      name: 'Petar Barbov',
      role: 'Berber Profesionist · Ndër anëtarët e parë'
    },
    timeline: {
      label: 'Historia',
      title: 'Po ndërtojmë diçka më të madhe.',
      items: [
        { year: '2025', event: 'Themelohet Barbers Unity - një ide e lindur nga lodhja e telefonatave pa fund dhe takimeve të humbura.' },
        { year: '2025', event: 'Platforma lançohet në versionin Beta.' },
        { year: 'Tani', event: 'Zgjerimi i rrjetit - më shumë berberë, më shumë qytete, mjete më të mira për të gjithë.' }
      ]
    },
    cta: {
      eyebrow: 'Vende të kufizuara - rezervo para se të mbushen',
      title: 'Dëshiron të jesh pjesë e historisë?',
      description: "Pavarësisht nëse je një berber apo klient, ka gjithmonë një vend për ty në komunitetin Barbers Unity.",
      findBarber: 'Gjej një Berber',
      getInTouch: 'Na Kontakto'
    }
  },
  contact: {
    title: 'Na Kontakto',
    getInTouch: {
      title: 'Na Kontakto',
      description: 'Ke pyetje rreth Barbers Unity? Jemi këtu për të të ndihmuar! Na shkruaj në cilindo nga rrjetet tona sociale ose na dërgo një mesazh direkt.',
      info: "Ke pyetje rreth Barbers Unity? Jemi këtu për të të ndihmuar - na shkruaj në cilindo kanal më poshtë."
    },
    followUs: 'Na Ndiq',
    b2b: {
      text: "<strong>Je berber?</strong> Lëre formën - rezervo një telefonatë falas 20-minutëshe dhe do të konfigurojmë gjithçka së bashku.",
      button: 'Rezervo një Telefonatë Falas'
    },
    success: {
      title: 'Mesazhi u Dërgua!',
      desc: "Faleminderit që na kontaktove. Do të të kthejmë përgjigje sa më shpejt të jetë e mundur.",
      button: 'Dërgo një tjetër'
    },
    form: {
      name: 'Emri',
      namePlaceholder: 'Emri yt',
      email: 'Email',
      emailPlaceholder: 'emaili@yt.com',
      message: 'Mesazhi',
      messagePlaceholder: 'Na trego si mund të të ndihmojmë...',
      send: 'Dërgo Mesazhin'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Vende të kufizuara - tani po pranojmë berberë të rinj',
      mainTitle: 'Mos e menaxho më biznesin<br><span class="title-accent">në mënyrë manuale.</span>',
      mainDesc: 'Çdo telefonatë e humbur janë para që të ikin nga duart. Çdo klient që nuk paraqitet të djeg një orar të vlefshëm. Barbers Unity të ofron një sistem profesional që e mban kalendarin tënd plot dhe klientët të informuar.',
      bookCall: 'Rezervo një Telefonatë Falas për Konfigurim',
      seeDashboard: 'Shiko Panelin',
      trust: ['Konfigurim falas', 'Pa kontrata', 'Gati për punë në 10 minuta']
    },
    loss: {
      beforeLabel: 'Pa Barbers Unity',
      afterLabel: 'Me Barbers Unity',
      without: [
        'Humbet telefonata ndërsa je duke qethur',
        'Klientë që s\'vijnë dhe të djegin oraret bosh',
        'Konfirmon çdo rezervim me dorë',
        'Bllok shënimesh apo tabela Excel-i të rrëmujshme',
        'Nuk e di se cilat shërbime të sjellin më shumë fitim'
      ],
      with: [
        'Klientët rezervojnë vetë online, 24/7',
        'Kalendari përditësohet direkt, pa u lodhur fare',
        'Panel profesional, gjithmonë i organizuar',
        'Historiku i plotë i rezervimeve dhe raporti i shërbimeve',
        'Funksionon në disa shtete dhe gjuhë'
      ]
    },
    features: {
      label: 'Çfarë përfiton',
      heading: 'Gjithçka që i duhet një berberi profesionist',
      items: [
        { title: 'Faqja jote profesionale e rezervimeve', desc: 'Një link i pastër me emrin tënd që mund ta ndash kudo - Instagram bio, WhatsApp, Google. Klientët shohin shërbimet, çmimet, oraret e lira dhe rezervojnë vetë. Pa telefonata, pa mesazhe pafund.', badge: 'Gati në pak minuta' },
        { title: 'Një kalendar i plotë posaçërisht për berberë', desc: 'Blloko kohën tënde të pushimit, vendos orarin e punës, menaxho shërbime të ndryshme me kohëzgjatje të ndryshme. Shiko gjithë javën tënde me një shikim dhe mos ki kurrë rezervime të dyfishta.', badge: null },
        { title: 'Historiku dhe preferencat e klientëve', desc: "Historiku i qethjeve, detajet e kontaktit dhe shënimet për çdo klient - të gjitha të organizuara. Dije saktësisht çfarë kërkon klienti para se të ulet në karrige.", badge: null },
        { title: 'Kujtesa automatike (së shpejti)', desc: 'Mesazhe rikujtuese në Email dhe WhatsApp do të dërgohen automatikisht para çdo takimi. Klientët që nuk paraqiten do të zhduken si problem. Lançohet së shpejti.', badge: 'Së shpejti' }
      ]
    },
    why: {
      label: 'Pse na zgjedhin berberët',
      heading: 'Karrigia jote.<br>Rregullat e tua.<br>Fitimi yt.',
      body: 'Barbers Unity e nxjerr biznesin tënd para klientëve që po kërkojnë aktivisht për një berber - pa pasur nevojë t\'i kërkosh ti, pa i ndjekur nga pas, dhe pa asnjë stres.',
      list: [
        'Zero gjueti klientësh - klientët vijnë vetë te ti',
        'Konfigurohet brenda një telefonate 20-minutëshe, plotësisht falas',
        'Funksionon perfekt me WhatsApp-in dhe email-in tënd aktual',
        "Pa kontrata - mund të largohesh kur të duash (por s'do kesh arsye)",
        'Suport i dedikuar nga njerëz të vërtetë, jo chatbot'
      ],
      highlights: [
        { title: 'Konfigurim i menjëhershëm', desc: "Një telefonatë 20 minutëshe. Je gati për punë para se ta mbyllësh." },
        { title: 'Krijuar për berberë', desc: 'Dizajnuar bashkë me berberët - jo thjesht për ta.' },
        { title: 'Shumë gjuhë', desc: 'EN, BG, HR, ALB, GER - kudo që të punosh.' },
        { title: 'Pa kontrata', desc: 'Fillo falas. Qëndro sepse funksionon, jo sepse je i detyruar.' }
      ]
    },
    testimonial: {
      quote: "Para Barbers Unity, humbisja 3-4 rezervime në javë vetëm nga thirrjet e humbura dhe mesazhet në WhatsApp që harroja t'u ktheja përgjigje. Me 20 € për qethje, ato janë 240-320 € që i humbisja çdo muaj. Tani kalendari im mbushet vetë. Thjesht shkoj në punë dhe qeth.",
      name: 'Petar Barbov',
      role: 'Berber Profesionist · Ndër anëtarët e parë'
    },
    cta: {
      eyebrow: 'Po pranojmë berberë në Sofje - kanë mbetur vetëm 3 vende këtë javë',
      mainTitle: 'Gati për ta pasur axhendën plot?',
      sub: "Rezervo një telefonatë falas 20-minutëshe. Ne do të konfigurojmë gjithçka bashkë - profilin, shërbimet dhe kalendarin tënd. Do të jesh gati për punë para se të mbyllet telefonata.",
      bookCall: 'Rezervo Telefonatën Falas Tani',
      member: 'Je tashmë anëtar?',
      login: 'Hyr në panelin tënd →'
    }
  },
  footer: {
    description: 'Ne lidhim berberët me klientët e tyre, thjeshtojmë rezervimet dhe rrisim bizneset.',
    quickLinks: {
      title: 'Lidhje të Shpejta',
      about: 'Rreth nesh',
      contact: 'Kontakt',
      demo: 'Demo'
    },
    legal: {
      title: 'Ligjore',
      privacy: 'Politika e Privatësisë',
      terms: 'Kushtet e Shërbimit'
    },
    followUs: 'Na Ndiq',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Të gjitha të drejtat e rezervuara.'
  },
  tailwindMessage: "Tailwind CSS funksionon në Vue 3! 🎉",
  clickMe: "Kliko këtu",
  previous: 'Kthehu',
  notFound: {
    title: 'Faqja Nuk u Gjet',
    description: "Faqja që po kërkon nuk ekziston ose është zhvendosur.",
    backHome: 'Kthehu në Fillim'
  },
  cookies: {
    title: 'Cilësimet e Cookies',
    message: 'Ne përdorim cookies për të përmirësuar përvojën tënde, për të analizuar trafikun e faqes dhe për të ofruar përmbajtje të përshtatur. Duke vazhduar të përdorësh faqen tonë, ti pranon përdorimin e cookies.',
    decline: 'Refuzo',
    accept: 'Prano të Gjitha'
  },
  map: {
    eyebrow: 'Gjej një Berber',
    heading: 'Berberët Pranë Teje',
    searchPlaceholder: 'Kërko me qytet ose emër berberi...',
    loading: 'Po ngarkon hartën...',
    error: {
      title: 'Harta nuk u ngarkua',
      desc: 'Pati një problem me ngarkimin e hartës. Të lutem provo sërish.',
      retry: 'Provo sërish'
    },
    results: 'rezultate',
    result: 'rezultat',
    bookNow: 'Rezervo Tani'
  },
  privacy: {
    intro: 'Mirë se vjen në Barbers Unity. Ne e respektojmë privatësinë tënde dhe jemi të përkushtuar të mbrojmë të dhënat e tua personale. Kjo politikë privatësie të informon se si ne kujdesemi për të dhënat e tua kur viziton faqen tonë dhe të tregon për të drejtat e tua të privatësisë dhe si të mbron ligji.',
    sections: {
      collect: {
        title: '1. Informacioni që mbledhim',
        desc: 'Ne mund të mbledhim, përdorim, ruajmë dhe transferojmë lloje të ndryshme të dhënash personale rreth teje, të cilat i kemi grupuar si më poshtë:',
        items: [
          '<strong>Të Dhënat e Identitetit</strong> përfshijnë emrin, mbiemrin, emrin e përdoruesit ose identifikues të ngjashëm.',
          '<strong>Të Dhënat e Kontaktit</strong> përfshijnë adresën e emailit dhe numrat e telefonit.',
          '<strong>Të Dhënat Teknike</strong> përfshijnë adresën e protokollit të internetit (IP), llojin dhe versionin e shfletuesit, zonën kohore, dhe teknologji të tjera në pajisjet që përdor për të aksesuar këtë faqe.'
        ]
      },
      use: {
        title: '2. Si i përdorim të dhënat e tua',
        desc: 'Ne do t\'i përdorim të dhënat e tua personale vetëm kur ligji na e lejon. Më së shpeshti, do t\'i përdorim të dhënat e tua në rastet e mëposhtme:',
        items: [
          'Kur duhet të zbatojmë kontratën që jemi gati të lidhim ose kemi lidhur me ty (p.sh., rezervimi i një takimi).',
          'Aty ku është e nevojshme për interesat tona legjitime dhe kur interesat apo të drejtat e tua themelore nuk dalin mbi këto interesa.',
          'Kur duhet të zbatojmë një detyrim ligjor.'
        ]
      },
      contact: {
        title: '3. Na Kontakto',
        desc: 'Nëse ke ndonjë pyetje në lidhje me këtë politikë privatësie ose praktikat tona, të lutem na shkruaj në kanalet tona të kontaktit.'
      }
    }
  },
  pricing: {
    title: 'Çmime të thjeshta',
    subtitle: 'Një plan. Gjithçka e përfshirë. Muaji i parë falas.',
    price: '35',
    period: '/muaj',
    trial: 'Muaji i parë FALAS',
    cta: 'Fillo provën falas',
    features: [
      'Rezervime të pakufizuara',
      'Njoftime për klientët',
      'QR kod & gjenerues story',
      'Kalendar për disa punonjës',
      'Panel analitik',
      'Suport prioritar'
    ]
  },
  terms: {
    title: 'Kushtet e Shërbimit',
    intro: 'Mirë se vjen në Barbers Unity. Duke përdorur platformën tonë, ti pranon këto kushte. Të lutem lexoji me kujdes.',
    sections: {
      account: {
        title: '1. Regjistrimi i llogarisë',
        desc: 'Ti duhet të japësh informacion të saktë kur krijon një llogari. Je përgjegjës për ruajtjen e sigurisë së kredencialeve të tua.'
      },
      usage: {
        title: '2. Përdorimi i pranueshëm',
        desc: 'Ti pranon të mos keqpërdorësh platformën, të mos ndërhysh në funksionimin e saj normal dhe të mos përpiqesh të aksesosh përmes një metode tjetër nga ndërfaqja që ne ofrojmë.'
      },
      fees: {
        title: '3. Abonimi dhe tarifat',
        desc: 'Shërbimet tona faturohen mbi bazë abonimi. Të gjitha tarifat janë të pakthyeshme përveç rasteve kur kërkohet nga ligji.'
      },
      liability: {
        title: '4. Kufizimi i përgjegjësisë',
        desc: 'Barbers Unity ofrohet "siç është". Ne nuk jemi përgjegjës për ndonjë dëm indirekt, të rastësishëm ose pasues që lind nga përdorimi i platformës.'
      }
    }
  },
  loading: {
    title: 'Po ngarkohet...',
    message: 'Të lutem prit'
  },
  modal: {
    registerTitle: 'Zgjidh Llojin e Llogarisë',
    businessTitle: 'Regjistrohu si Biznes',
    businessDesc: 'Sallon / Berber',
    customerTitle: 'Regjistrohu si Klient',
    customerDesc: 'Rezervo takime'
  }
}